<template lang="pug">
    #employee-section
        loading-dialog(:loading="loadContract")
        v-alert( type='error' v-model='noContract' ) 
            span El empleado no posee ningun contrato. Haga clic en 'Ir a contratos' para crear uno.
            v-btn( class='my-0' @click='$router.push({ name: "contract-list" })' ) ir a contratos
        div(v-if="!loadContract")
            employee-all-contracts(v-if="!employeeHasActiveContract" :arrContractsProp="allContracts" ref="invalidContractsForm")
            employee-has-active-contract(v-else :contractProp="contractActive")
            
</template>

<script>
/* components */
import {LoadingDialog} from '@/components/reusable_components'
import EmployeeHasActiveContract from './EmployeeHasActiveContract'
import EmployeeAllContracts from './EmployeeAllContracts'
/* services */
import EmployeeService from '@/services/api/employee'
/* libraries */
import moment from 'moment'
export default {
    name: 'employee-contract',
    // props: {},
    data: function(){
        return {
            employeeHasActiveContract : null,
            loadContract:false,
            contract : null,
            contractsInactive:[],
        }
    },
    computed: {
        noContract() {
            return this.contractsInactive.length < 1 && !this.loadContract
        },
        contractActive:{
            get(){
                return this.contract
            },
            set(contract){
                this.contract = contract
            }
        },
        /**
         * 
         */
        allContracts: {
            get:function () {
                return this.contractsInactive
            },
            set: function (contracts) {
                this.contractsInactive = contracts
            }
        }
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        /**
         * 
         */
        async fetchEmployeeContract(){
            const employeeId = this.getEmployeeId()
            let employee  = await EmployeeService.fetchById(employeeId)
            console.log(employee,'data employeeeee')
            this.setEmployeeHasActiveContract( employee )
            this.setAllContracts( employee.all_contract, employee )
            
        },
        // -- Data handling and transformations
        /**
         * 
         */
        getEmployeeId(){
            return this.$route.params.id
        },
        /**
         * 
         */
        setEmployeeHasActiveContract(employee){
            if(employee.active_contract){
                this.employeeHasActiveContract = true
                this.contractActive = employee.active_contract
            }
            else{
                this.employeeHasActiveContract = false
            }
        },
        /**
         * 
         */
        setLoadContract(value){
            this.loadContract = value
        },
        /**
         * 
         */
        setAllContracts(contracts, employeeInfo){
            this.allContracts = this.formatDateContract(contracts, employeeInfo)
        },
        /**
         * 
         */
        formatDateContract(contracts,employeeInfo){
            return contracts.map(contract=>{

                let newContract = {...contract}
                newContract.created_at = moment( contract.created_at ).format('DD/MM/YYYY')
                newContract.updated_at = moment( contract.updated_at ).format('DD-MM-YYYY')
                newContract.text = `${employeeInfo.names} ${employeeInfo.last_name1} ${newContract.created_at}` 
                return newContract
            })
        },

        // -- Validations and Error handling
        // -- Other functions
        // -- Vuex mappings
    },
    // watch: {},
    components: {
        'employee-has-active-contract':EmployeeHasActiveContract,
        'employee-all-contracts':EmployeeAllContracts,
        'loading-dialog' : LoadingDialog,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    async mounted () {
        this.setLoadContract(true)
        await this.fetchEmployeeContract()
        this.setLoadContract(false)
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>